import {FC, useEffect, useRef} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import FormPayStubNew from 'components/blocks/forms/FormPayStubNew/index'
// import {klaviyoTrack, posthogTrack} from 'src/utils'

import s from './TemplateCreateDocumentPayStubNew.module.scss'

const cx = cn.bind(s)

interface ITemplateCreateDocumentPayStubNewProps {
	className?: string
}

const TemplateCreateDocumentPayStubNew: FC<ITemplateCreateDocumentPayStubNewProps> = ({
	className,
}) => {
	const wrapperRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		// TODO: uncomment analytic events later
		// posthogTrack('[Paystub] Create paystub page opened')
		// klaviyoTrack('Page opened', {page: 'paystub', href: window?.location?.href})
	}, [])
	return (
		<div ref={wrapperRef} className={cx('wrapper', className)}>
			<div className={cx('line')} />
			<div className={cx('wrapper__content', className)}>
				<FormPayStubNew ref={wrapperRef} />
			</div>
		</div>
	)
}

TemplateCreateDocumentPayStubNew.displayName = 'TemplateCreateDocumentPayStubNew'

export default observer(TemplateCreateDocumentPayStubNew)
